import React, { useEffect } from 'react'
import { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import HeaderLayout from 'layout/HeaderLayout';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import ChildStep from './ChildStep';
import { useParams } from 'react-router-dom';
import axiosInstance from 'custom-axios';
import PropTypes from 'prop-types';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import { styled } from '@mui/material/styles';
import SummarizeIcon from '@mui/icons-material/Summarize';
import BadgeIcon from '@mui/icons-material/Badge';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import GradingIcon from '@mui/icons-material/Grading';
import ClientFormActivity from 'views/admin-components/pages/admin-client-form/ClientFormActivity';
import ClientPortfolioDrawer from 'views/admin-components/pages/admin-client-form/ClientPortfolioDrawer';
import { toast } from 'react-toastify';
import { FormProvider, useForm } from 'react-hook-form';
import { defaultPersonalDetails, defaultRegulatoryDetails } from 'store/constant';

const parentSteps = ['Household', 'Accounts', /* 'Client Group', */ 'Risk Questionnaire', 'Review', 'Agreement', 'Thank You'];

const ClientFormSteps = () => {

    const [activeParentStep, setActiveParentStep] = useState(0); // set 0 to start from House hold/ Staring from client form
    const [activeChildStep, setActiveChildStep] = useState(0);

    // const [clientPortfolioData, setClientPortfolioData] = useState([])
    const [parentErrorStepIndex, setParentErrorStepIndex] = useState([false, false, false, false]); // Track error for which parent step have errors....
    const { id } = useParams();
    let userId = id ? id : 0;

const defaultMergeValue = { ...defaultRegulatoryDetails, defaultPersonalDetails }
    const methods = useForm({
        defaultValues: defaultMergeValue,
        mode: 'onChange',
    });

    const fetchFormStep = async () => {

        try {

            const response = await axiosInstance.get(`api/fetch-form-step/${userId}`);

            if (response.data) {
                setActiveParentStep(response.data?.parent_step)
                setActiveChildStep(response.data?.child_step)
                if (response.data.parent_error_step) {

                    const parentErrorStepArray = response?.data?.parent_error_step
                        .split(",") // Split the string into an array
                        .map((value) => value === "1"); // Convert "1" to true and "0" to false

                    setParentErrorStepIndex(parentErrorStepArray)
                }
            }

        } catch (error) {
            // console.error(error.message);
        }
    };




    const clickOnParentStep = async (index) => {

        let endPoint = `api/change-form-step`;

        // child step 0 for new parent step
        const submitData = { user_id: userId ? userId : 0, parent_step: index, child_step: 0 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {

                setActiveParentStep(index)
                // setActiveStep(0);
                setActiveChildStep(0)
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    }

    /* const nextStep = () => setActiveParentStep((prev) => prev + 1);
    const prevStep = () => setActiveParentStep((prev) => prev - 1);
    const nextLastStep = () => {
        // console.log('Successfully Complete Form')
    };
    */
    const parentStepValidation = (activeStep) => {
        return parentErrorStepIndex[activeStep] === true;
    };


    // const memoizedValidation = useMemo(() => {
    //     return parentSteps.map((_, index) => parentStepValidation(index));
    // }, [parentErrorStepIndex]);


    useEffect(() => {
        if (userId) { fetchFormStep() }
    }, [])

    // console.log(activeParentStep, activeChildStep)

    return (
        <>
            {/* <HeaderLayout /> */}

            <FormProvider {...methods}>
                <Stepper activeStep={activeParentStep} className=' padding-left35px padding-right35px' connector={<QontoConnector />} sx={{ padding: '35px', backgroundColor: '#fff' }}>

                    {parentSteps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};

                        if (parentStepValidation(index)) {
                            // console.log("IN", index);
                            labelProps.optional = (
                                <Typography variant="caption" color="error">Error</Typography>
                            );
                            labelProps.error = true;
                        }

                        return (
                            <Step
                                key={label}
                                {...stepProps}
                            // error={parentStepValidation(index)}
                            >
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                    {...labelProps}
                                    onClick={() => clickOnParentStep(index)}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    {label}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {/* {console.log(activeParentStep, activeChildStep)} */}

                {/* --------THIS IS THE FINAL STEP OF PARENT STEPPER AND SET PORTFOLIO/eSign here in this component.. */}
                {
                    activeParentStep !== parentSteps.length ? (
                        <>
                            <ChildStep
                                userId={userId}
                                activeParentStep={activeParentStep}
                                setActiveParentStep={setActiveParentStep}
                                activeChildStep={activeChildStep}
                                setActiveChildStep={setActiveChildStep}
                                setParentErrorStepIndex={setParentErrorStepIndex}
                                parentErrorStepIndex={parentErrorStepIndex}
                            />

                            <div className='text-center container mt-5'></div>

                            {/* parent step next/back button */}
                            {/* <div className='text-center container mt-5'>
                        <Button variant="contained" className='raintree-btn-green' disabled={activeParentStep === 0} onClick={prevStep}>
                            PREVIOUS
                        </Button>

                        <Button variant="contained" className='raintree-btn-green m-3' onClick={nextStep}>
                            {activeParentStep === parentSteps.length - 1 ? 'FINISH' : 'CONTINUE'}
                        </Button>
                    </div> */}

                        </>

                    ) : (
                        null
                    )
                }
            </FormProvider>
            {/* <ClientFormActivity called_from='admin' userId={userId} /> */}
            <ClientPortfolioDrawer called_from='admin' userId={userId} setActiveParentStep={setActiveParentStep} setActiveChildStep={setActiveChildStep} />
        </>
    )
}

export default ClientFormSteps;


const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#2196f3 ',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#4a934a',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));



const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    // backgroundColor: '#4a934a',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 35,
    height: 35,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        // backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        background: '#2196f3',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        // backgroundImage:'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        background: '#4a934a',
    }),
}));


function ColorlibStepIcon(props) {

    const { active, completed, className } = props;

    const icons = {
        1: <AccountBalanceIcon />,
        2: <BadgeIcon />,
        3: <GroupAddIcon />,
        4: <DynamicFormIcon />,
        5: <GradingIcon />,
        6: <SummarizeIcon />,
        7: <CheckCircleIcon />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};


/* const SignUpPortfolioComponent = ({ email }) => {
    return (
        <Grid container>
            <Grid container direction="column" justifyContent="center">
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom component="div">
                        Congratulations
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ maxWidth: '325px', maxHeight: '325px', display: '-webkit-inline-box' }}>

                </Grid>
            </Grid>
        </Grid>
    );
}; */

